<div [ngClass]="[
		styles.thumbnail,
		cssClass ? cssClass : ''
	]" #bgThumbnail [style.height.px]="heightStyle" [style.width.px]="widthStyle" [style.backgroundSize]="bgSizeStyle" [style.backgroundImage]="bgImageStyle" role="img" [attr.aria-label]="altTxt">
</div>
